export default __webpack_public_path__ + "static/media/kid-toothbrush-smile.136d3a16.jpg";